import { useState, useEffect, Link, Icon, Input, Toast, useNavigate, useForm } from "../utils/commonImports";
import { _api } from '../auth/Api';

const ForgotPasswordPage = () => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [counter, setCounter] = useState(60);
  const [requestResponse, setRequestResponse] = useState(null);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm();

  useEffect(() => {
    let timer;
    if (step === 2 && counter > 0) {
      timer = setTimeout(() => setCounter(counter - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [counter, step]);

  const onEmailSubmit = async (data) => {
    const payload = { emailAddress: data.email };
    setLoading(true);
    try {
      await _api("POST", "PortalUser/ForgotPassword", payload, (res) => {
        if (res.isSuccess) {
          Toast.fire({ icon: "success", title: res?.message });
          setRequestResponse(res.data);
          setTimeout(() => {
            setStep(2);
            setCounter(60);
            setLoading(false);
          }, 1500);
        } else {
          setLoading(false);
          Toast.fire({ icon: "error", title: res?.message });
        }
      });
    } catch (err) {
      setLoading(false);
      console.log("[Email Error]", err);
    }
  };

  const onOTPSubmit = async (data) => {
    if (!data.otp || data.otp.length !== 4) {
      Toast.fire({ icon: "error", title: "Please enter full 4-digit OTP" });
      return;
    }
    const payload = { userId: requestResponse?.userId, otpCode: data.otp };
    setLoading(true);
    try {
      await _api("POST", "PortalUser/OTPVerification", payload, (res) => {
        if (res.isSuccess) {
          Toast.fire({ icon: "success", title: res?.message });
          setTimeout(() => {
            setStep(3);
            setLoading(false);
          }, 1500);
        } else {
          setLoading(false);
          Toast.fire({ icon: "error", title: res?.message });
        }
      });
    } catch (err) {
      setLoading(false);
      console.log("[OTP Error]", err);
    }
  };

  const onResetSubmit = async (data) => {
    if (data.newPassword !== data.confirmPassword) {
      Toast.fire({ icon: "warning", title: "Passwords do not match" });
      return;
    }
    const payload = { userId: requestResponse?.userId, newPassword: data.newPassword };
    setLoading(true);
    try {
      await _api("POST", "PortalUser/UpdatePassword", payload, (res) => {
        if (res.isSuccess) {
          Toast.fire({ icon: "success", title: res?.message });
          setTimeout(() => {
            navigate("/sign-in");
            setLoading(false);
          }, 1500);
        } else {
          setLoading(false);
          Toast.fire({ icon: "error", title: res?.message });
        }
      });
    } catch (err) {
      setLoading(false);
      console.log("[Reset Error]", err);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100"
      style={{ background: "url('assets/images/changan-bg/banner.jpg') center/cover no-repeat" }}>

      <div className="bg-white rounded-lg shadow-lg p-5 w-100 ForgetPassMobile" style={{ maxWidth: "500px" }}>
        <div className="text-center mb-4">
          <img src="assets/images/changan-logo/logo-with-text.png" alt="Logo" style={{ width: "50%", marginBottom: "20px" }} />
          <p className="text-secondary-light text-sm">
            {step === 1 && "Enter your registered email address to receive a one-time password (OTP)."}
            {step === 2 && "We’ve sent a 4-digit OTP to your email. It will expire in 2 minutes."}
            {step === 3 && "Enter and confirm your new password to complete the reset."}

          </p>
        </div>

        {step === 1 && (
          <form onSubmit={handleSubmit(onEmailSubmit)}>
            {/* <span className="text-sm text-secondary-light mb-2">Email Address</span> */}
            <div className="icon-field mb-0">
              <span className="icon top-50 translate-middle-y"><Icon icon="mage:email" /></span>
              <input
                {...register("email", { required: "Email is required" })}
                type="email"
                className="form-control h-45-px bg-neutral-50 radius-5"
                placeholder="Enter your email"
              />
            </div>
            {errors.email && <span class="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors.email.message}</span>}
            <button disabled={loading} className="btn btn-primary w-100 mt-16">
              {loading ? <span className="spinner-border spinner-border-sm" /> : "Continue"}
            </button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleSubmit(onOTPSubmit)}>
            <div className="d-flex justify-content-center mb-16">
              <Input.OTP
                length={4}
                inputType="numeric"
                value={watch("otp")}
                onChange={(val) => setValue("otp", val)}
                autoFocus
                variant="outlined"
                style={{ gap: 10 }}
              />
            </div>
            <button disabled={loading} className="btn btn-primary w-100">
              {loading ? <span className="spinner-border spinner-border-sm" /> : "Verify OTP"}
            </button>
            <div className="text-center text-sm" style={{ marginTop: "12px" }}>
              {counter === 0 ? (
                <a href="#" onClick={() => { handleSubmit(onEmailSubmit)({ email: watch("email") }); }} style={{ color: "#10477fe3", textDecoration: "none", }} className="d-inline-flex align-items-center gap-1">
                  Resend OTP <Icon icon="mdi:reload" className="me-1" />
                </a>
              ) : (
                `Didn't receive OTP? Resend in ${counter}s`
              )}
            </div>
          </form>
        )}

        {step === 3 && (
          <form onSubmit={handleSubmit(onResetSubmit)}>
            <div className="icon-field">
              <span className="icon top-50 translate-middle-y"><Icon icon="mdi:lock-outline" /></span>
              <input
                {...register("newPassword", { required: "New password is required" })}
                type="password"
                className="form-control h-45-px bg-neutral-50 radius-5"
                placeholder="Enter new password"
              />
            </div>
            {errors.newPassword && <span class="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors.newPassword.message}</span>}
            <div className="icon-field mt-3">
              <span className="icon top-50 translate-middle-y"><Icon icon="mdi:key-variant" /></span>
              <input
                {...register("confirmPassword", { required: "Please confirm password" })}
                type="password"
                className="form-control h-45-px bg-neutral-50 radius-5"
                placeholder="Confirm new password"
              />
            </div>
            {errors.confirmPassword && <span class="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors.confirmPassword.message}</span>}
            <button disabled={loading} className="btn btn-primary w-100  mt-3">
              {loading ? <span className="spinner-border spinner-border-sm" /> : "Reset Password"}
            </button>
          </form>
        )}

        <div className="mt-3 text-center text-sm">
          <p className="mb-0">
            Remembered your password? <Link to="/sign-in" className="text-primary-600">Sign In</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;